import { QuoteApiModel } from '~/lib/api/smartsend/types';
import { P2GGrid, P2GRadio, P2GText } from '@parcel2go/core-ui';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { useMemo } from 'react';
import { CoverExtra, ExtendedBaseCoverExtra } from '~/lib/consts/extras';
import { useServiceLogo } from '~/hooks/use-service-logo';

type props = {
  isXs: boolean;
  quote: QuoteApiModel;
  includeProtection: boolean;
  selected: boolean;
  tagline?: string;
  onClick: () => void;
};

const ServiceCard = ({ isXs, quote, includeProtection, selected, onClick, tagline }: props) => {
  const { getSrc } = useServiceLogo();

  const price = useMemo(() => {
    if (includeProtection) {
      // P2G
      const optionWithBaseProtection = quote.Options.find((x) => x.Extras.some((y) => y.Id === ExtendedBaseCoverExtra));
      if (optionWithBaseProtection) {
        return optionWithBaseProtection;
      }

      // Others
      const optionWithCover = quote.Options.find((x) => x.Extras.some((y) => y.Id === CoverExtra));
      if (optionWithCover) {
        return optionWithCover;
      }
    }

    return quote.Options.find((x) => x.Extras.every((y) => y.Id !== ExtendedBaseCoverExtra)) || quote.Options[0];
  }, [quote, includeProtection]);

  const collectionDescription = useMemo(() => {
    switch (quote.Service.CollectionType) {
      case 'Shop':
        return 'Drop Off';
      default:
        return quote.Service.CollectionType;
    }
  }, [quote.Service.CollectionType]);

  return (
    <P2GGrid container spacing={2} alignItems="center" wrap="nowrap">
      {!isXs && (
        <P2GGrid item flexShrink={1}>
          <img src={getSrc(quote.Service)} alt={quote.Service.Name} width="95" />
        </P2GGrid>
      )}
      <P2GGrid item flexGrow={1}>
        <P2GRadio
          onClick={onClick}
          checked={selected}
          label={
            <P2GText component="p">
              <strong>
                {quote.Service.Name}
                {!isXs && tagline && (
                  <P2GText ml={1} variant="caption">
                    ({tagline})
                  </P2GText>
                )}
              </strong>
              <P2GText variant="caption" component="p">
                {collectionDescription}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                {quote.Service.PrinterRequired ? (
                  <P2GText variant="caption" colour="error">
                    Printer Required
                  </P2GText>
                ) : (
                  <P2GText variant="caption">No Printer Required</P2GText>
                )}
              </P2GText>
              {isXs && (
                <P2GText component="p">
                  <strong>{toDisplayCurrency(null, price.TotalPriceExVat)} *</strong>
                </P2GText>
              )}
            </P2GText>
          }
        />
      </P2GGrid>
      <P2GGrid item>
        {isXs ? (
          <img src={getSrc(quote.Service)} alt={quote.Service.Name} width="65" />
        ) : (
          <P2GText>
            <strong>{toDisplayCurrency(null, price.TotalPriceExVat)} *</strong>
          </P2GText>
        )}
      </P2GGrid>
    </P2GGrid>
  );
};
export default ServiceCard;
